function getDeviceType() {
	var width = window.outerWidth;

    if(width < 768) {
        return "mobile";
    } else if(width >= 768 && width < 992) {
        return "tablet";
    } else {
        return "desktop";
    }
}

export {
	getDeviceType
}